const routes = [
  {
    path: "/estoque/devolucoes",
    component: () => import("@/views/dashboard/devolucoes/Devolucoes.vue"),
    meta: {
      menu: "dashboard",
      title: { text: "global.devolucao", plural: true },
      icon: "mdi-truck-delivery-outline",
      breadcrumb: [
        { text: "global.home", to: { path: "/" } },
        { text: "global.devolucao", plural: true },
      ],
      permission: { componente: "Devolucoes" },
    },
  },
];

export default routes;
